import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, required,
} from "react-admin";
import CreateView from '../../../../components/CreateView';
import EditView from "../../../../components/EditView";

import ShowView from "../../../../components/ShowView";

export const CustomerRatingList = (props) => (

  <List {...props}>
    <Datagrid rowClick="edit"  sort={{ field: 'order', order: 'ASC' }}>
      {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
      <TextField source="title" />
      <TextField source="order" />

    </Datagrid>
  </List>
);

export const CustomerRatingEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="order" validate={required()} />
    <TextInput source="title" validate={required()} />
  </EditView>
);

export const CustomerRatingShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="order" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const CustomerRatingCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="order" label="ترتیب" />
    <TextInput source="title" label="عنوان" />
  </CreateView>
);
